<template>
  <div>
    <div class="content__header">
      <b-form-group label="Border width">
        <b-form-spinbutton
          id="border-width-step"
          v-model="width"
          min="0"
          max="10"
          step="1"
          @change="onBorderWidthChange"
        />
      </b-form-group>
      <b-form-group label="Border radius">
        <b-form-spinbutton
          id="border-radius-step"
          v-model="radius"
          min="0"
          max="20"
          step="1"
          @change="onBorderRadiusChange"
        />
      </b-form-group>

      <b-form-group label="Border style">
        <b-form-select
          v-model="style"
          :options="options"
          @change="onBorderStyleChange"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>

const options = [
  { value: 'none', text: 'None' },
  { value: 'solid', text: 'Solid' },
  { value: 'dotted', text: 'Dotted' },
  { value: 'dashed', text: 'Dashed' },
  { value: 'groove', text: 'Groove' },
];

export default {
  name: 'BordersEditorComponent',
  props: [
    'borderWidth',
    'borderStyle',
    'borderColor',
    'borderRadius',
  ],
  data() {
    return {
      options,
      color: null,
      style: 'none',
      radius: null,
      width: null,
    };
  },
  methods: {
    onBorderStyleChange(val){
      this.$emit('get-border-style', val);
    },
    onBorderWidthChange(val) {
      this.$emit('get-border-width', val);
    },
    onBorderRadiusChange(val) {
      this.$emit('get-border-radius', val);
    },
  },
  mounted() {
    this.color = this.borderColor;
    this.style = this.borderStyle;
    this.radius = this.borderRadius;
    this.width = this.borderWidth;
  },
};
</script>

<style scoped lang="scss">
.content__header {
  display: flex;
  gap: 20px;
}
</style>